var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "image-select-container" }, [
    _c(
      "div",
      { staticClass: "image-select__input" },
      [
        _c(_setup.inputText, {
          attrs: { value: _setup.form },
          on: {
            change: function ($event) {
              _setup.form = $event
            },
          },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "fill-canvas full-height overflow-auto pa-1" },
      _vm._l(_setup.images_convert, function (category) {
        return _c("div", { key: category.id }, [
          _c("div", { staticClass: "item-icon__group" }, [
            _vm._v(" " + _vm._s(category.name) + " "),
          ]),
          _c(
            "div",
            { staticClass: "item-icon__container" },
            _vm._l(category.children, function (item) {
              return _c(
                "button",
                {
                  key: item.id,
                  staticClass: "item-icon",
                  class: { "item-icon-active": item.id === _vm.value },
                  on: {
                    click: function ($event) {
                      return _setup.onToggleImage(item)
                    },
                  },
                },
                [
                  _c(_setup.MapImage, { attrs: { src: item.path } }),
                  _c("div", {
                    style: {
                      "background-image": `url(${item.path})`,
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ])
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }